import React from 'react';
import PropTypes from 'prop-types';

var SchemaErrorComponent = function SchemaErrorComponent(_ref) {
  var name = _ref.name,
      message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 5,
      border: '1px solid #bbb',
      borderCollapse: 'collapse',
      borderRadius: 2
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 24,
      marginBottom: 5
    }
  }, "Form could not be rendered, because of invalid form schema."), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 20,
      marginBottom: 5
    }
  }, name, ":"), /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 5
    }
  }, message), /*#__PURE__*/React.createElement("p", null, "If you don't know what this error means, please contact site administrator."));
};

SchemaErrorComponent.propTypes = {
  name: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};
export default SchemaErrorComponent;